import React, { useContext, useEffect, useState } from "react";
import { ProjectContext } from "../../ProjectContext";
import { useNavigate } from "react-router-dom";
import { useConnectModal } from "@rainbow-me/rainbowkit";
import axios from "axios";

function StakeModal() {
  const {
    copyaddress,
    account,
    toastSuccess,
    library,
    dbuser,
    formatAddress,
    toastError,
    settings,
    esigner,
    ethers,
    getuserDB,
    x2balance,
    Refaddress,
    Ubalance,
    Dbalance,
    getsmcs,
    Maincontract, Usdtcontract,Defincontract,CheckReffaral
  } = useContext(ProjectContext);

  const [selectedCrypto, setSelectedCrypto] = useState(1); // Default to USDT (1)
  const handleSelect = (crypto) => {
    setSelectedCrypto(crypto);
  };

  const [show, setShow] = useState(false);
  const [amount, setAmount] = useState(0);
  const [trdone, setTrdone] = useState(false);
  const [hash, setHash] = useState("");
  const [referral, setReferral] = useState("");
  const [Pkg, setPkg] = useState("");
  const [loading, setLoading] = useState(false); // New loading state to handle the loader
  const [isDivisibleBy10, setIsDivisibleBy10] = useState(null);
const [Defin, setDefin] = useState(0);
  const { openConnectModal } = useConnectModal();
  var navigate = useNavigate();

  const onDeposit = async () => {
    setTrdone(true);
    setHash("");
    setLoading(true); // Set loading to true when the transaction starts
    
    // // Await the CheckReffaral() function and handle the result
    // const referralCheck = await CheckReffaral();
    // // If CheckReffaral() returns an error, stop the deposit process
    // if (referralCheck.code === 400) {
    //   setTrdone(false);
    //   setLoading(false);
    //   return; // Stop execution if referral is not active
    // }
    
    if (!account) {
      openConnectModal();
      toastError("Connect first");
      setTrdone(false);
      setLoading(false); // Stop loading if no account
      return;
    }
    
    if (amount < 20 || amount > 1000) {
      toastError("Amount must be between $20 to $1000!");
      setTrdone(false);
      setLoading(false); // Stop loading on invalid amount
      return;
    }
    let allowance;
    if (selectedCrypto === 1) {
        allowance = await Usdtcontract.allowance(account, settings.contract);
    }
    else
    {
        allowance = await Defincontract.allowance(account, settings.contract);
    }
    
    if (Number(ethers.utils.formatEther(allowance)) < (selectedCrypto == 1 ? ethers.utils.parseUnits(amount, 18).toString() : ethers.utils.parseUnits(Defin, 18).toString())) {
      try {
        if (selectedCrypto === 1) {
          const approv = await Usdtcontract.approve(
            settings.contract,
            ethers.utils.parseUnits(amount, 18).toString()
          );
          await approv.wait();
          toastSuccess("Token Approved");
        } else {
          const approv = await Defincontract.approve(
            settings.contract,
            ethers.utils.parseUnits(Defin, 18).toString()
          );
          await approv.wait();
          toastSuccess("Token Approved");
        }

        // Proceed after approval
        main(Maincontract);
      } catch (error) {
        console.log("error---------------", error);
        toastError("Token not approved");
        setTrdone(false);
        setLoading(false); // Stop loading on error
        return;
      }
    } else {
      // If allowance is sufficient, proceed with staking
      main(Maincontract);
    }
  };

  const main = async (Maincontract) => {
    console.log("Refaddress", Refaddress);

    try {
      const stk = await Maincontract.stake(Refaddress, ethers.utils.parseUnits(amount, 18).toString(), selectedCrypto);
      const receipt = await stk.wait();
      setHash(receipt.transactionHash);
      try {
        const res = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
          method: "transaction",
          submethod: "insert",
          user: account,
          ref: Refaddress,
          amount: amount,
          hash: receipt.transactionHash,
          key: process.env.REACT_APP_KEY,
        });
        if (!res.data.error) {
          toastSuccess("Transaction done");
          console.log("Transaction", res);
          setAmount(0);
          getsmcs();
        } else {
          toastError(`${res.data.error}`);
          console.log("Transaction failed", res.data.error);
        }
      } catch (err) {
        console.error("Error fetching data:", err);
      }
    } catch (error) {
      console.log("error---------------", error.data);
      if (error.code === "CALL_EXCEPTION" && error.data) {
        toastError(`Transaction failed: ${error.data.message || "Unknown error"}`);
      } else {
        toastError(`Transaction failed: ${error.message}`);
      }
    } finally {
      setTrdone(false); // Stop the transaction flag
      setLoading(false); // Stop loading
    }
  };

  const handleChange = (event) => {
    const value = event.target.value;
    setAmount(value);

    // Check if the entered value is divisible by 10
    if (value !== '' && !isNaN(value)) {
      setIsDivisibleBy10(Number(value) % 10 === 0);
    } else {
      setIsDivisibleBy10(null);  // Reset if the input is empty or not a number
    }
  };
  
  const fetchData = async () => {
    // console.log("DATA1", amount);
    try {
      // Perform calculations for token values
      const tmt = await Maincontract.calculatedefintoken(ethers.utils.parseUnits(amount.toString(), 18).toString());
      console.log("TMT", tmt.toString());
      // Update the state with the results
      setDefin(ethers.utils.formatEther(tmt)); // USDT equivalent after fee
    } catch (error) {
      console.error("Error calculating token values:", error);
      toastError("Error calculating token values");
    }
  };
  useEffect(() => {
    // Check if the necessary data is available
    if (amount) {
      fetchData();
    } else {
      setDefin(0);
    }
  }, [amount]);

  
  useEffect(() => {
    if (hash) {
      setTimeout(() => {
        // Programmatically simulate a click on the close button to dismiss the modal
        const closeButton = document.querySelector('[data-bs-dismiss="modal"]');
        if (closeButton) {
          closeButton.click();
        }
      }, 1000); // Close the modal after 1 second
    }
  }, [hash]);

  useEffect(() => {
    if (dbuser !== null) {
      if (dbuser.ref_address !== null) {
        setReferral(dbuser.ref_address);
      }
    }
  }, [dbuser, account]);

  return (
    <div>
      <div className="modal fade" id="exampleModalCenter">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Stake</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                disabled={loading} // Disable the close button when loading
              ></button>
            </div>
            <div className="modal-body">
              {/* <img src="./assets/img/tr_done.gif" width={250} /> */}
              {hash ?
                <div className="d-flex justify-content-center">
                  <img src="./assets/img/tr_done.gif" width={150} />
                </div>
                :
                <form>
                  <div className="d-flex flex-wrap crypto">
                    {["USDT", "DEFIN"].map((crypto, index) => (
                      <div
                        key={index}
                        className="form-check custom-checkbox me-5 mb-2"
                      >
                        <input
                          type="radio"
                          className="form-check-input custom-radio"
                          id={`customRadio${index}`}
                          name="crypto"
                          value={crypto}
                          checked={selectedCrypto === (crypto === "USDT" ? 1 : 2)} // Ensure the correct crypto is selected
                          onChange={() => {
                            const value = crypto === "USDT" ? 1 : 2;
                            setSelectedCrypto(value);
                          }}
                        />
                        <label
                          className="form-check-label"
                          htmlFor={`customRadio${index}`}
                        >
                          <span className="d-block text-black font-w500">
                            {crypto}
                          </span>
                        </label>
                      </div>
                    ))}
                  </div>
                  <div className="mb-3">
                    <div className="d-flex justify-content-between">
                      <label className="form-label text-black">Amount</label>
                      <label className="form-label text-black">
                        {selectedCrypto === 1
                          ? `$${Ubalance}`
                          : selectedCrypto === 2
                            ? `${Dbalance} ${process.env.REACT_APP_TOKEN_TICKER}`
                            : 0}
                      </label>
                    </div>
                    <input
                      type="text"
                      className="form-control"
                      value={amount}
                      onChange={handleChange}
                      placeholder="Enter Amount"
                      disabled={loading} // Disable input while loading
                    />
                    {selectedCrypto === 2 ?
                      <div className="mt-3 text-center">
                        <h3 className="mb-0">{Defin} {process.env.REACT_APP_TOKEN_TICKER}</h3>
                        <p>You Required {process.env.REACT_APP_TOKEN_TICKER}</p>
                      </div>
                      : ""
                    }
                    {isDivisibleBy10 === false && (
                      <small className="text-danger">Amount must be divisible by 10.</small>
                    )}
                  </div>
                  <div className="d-flex justify-content-center">
                    <button
                      type="button"
                      onClick={() => onDeposit()}
                      className="btn btn-sm text-white bg-new-primary"
                      disabled={loading || !isDivisibleBy10} // Disable the button while loading or if not divisible by 10
                    >
                      {loading ? "Processing..." : "Stake"}
                    </button>
                  </div>
                </form>
              }
              {loading && (
                <div className="d-flex justify-content-center mt-3">
                  <div className="spinner-border text-primary" role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                </div>
              )}
              {hash && (
                <div className="mt-3 text-center">
                  <h4>
                    <a
                      href={`${process.env.REACT_APP_EXPLORER}tx/${hash}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {formatAddress(hash)}
                    </a>
                    &nbsp;<i className="fa fa-copy" onClick={() => copyaddress(hash)}></i>
                  </h4>
                  <p>Transaction Hash</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default StakeModal;